const networkKey = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

export const isValidWithdrawalWallet = (address, network) => {
  const wallet = String(address || '').trim();
  if (wallet.length < 12 || wallet.length > 255 || /\s/.test(wallet)) return false;

  if (['TRC20', 'TRON'].includes(networkKey(network))) {
    return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(wallet);
  }
  return true;
};
